import insightsuite from "../../../assets/home/insight-suite.png";
import InsightfulAi from "../../../assets/home/InsightfulAi.svg";
import upRightArrow from "../../../assets/up-right-arrow-white.svg";
import upRightBlue from "../../../assets/up-right-arrow.svg";
import "./style.css";

export default function LaunchNext() {
  return (
    <div className="d-flex justify-content-center" style={{ backgroundColor: "#D5EAFB" }}>
      <div
        className="commonInlinePadding paddingBlockLaunch section-container">
        <div className="insideInsight">
          <div className="upperInsight">
            <div className="insightfulAIChip">
              <img src={InsightfulAi} alt="InsightfulAi" />
              <span style={{ color: "#676767" }}>
                <span className="typography">InsightSuite</span>™
              </span>
            </div>

            <div>
              <div
                className="off-black insightHeading"
                style={{ marginBottom: "0.625rem" }}
              >
                Know What to <br />
                <span className="green-accent">Launch Next</span>.
              </div>

              <div className="off-black Caption" style={{ opacity: "0.5" }}>
                InsightSuite™ scrapes millions of reviews and social posts to
                surface unmet needs and whitespace—then sizes the prize.
              </div>
            </div>

            <div>
              <button
                className="btn btn-outline-primary buttonText"
                style={{ border: "none" }}
                onClick={() => {
                  window.open(
                    "https://meetings.hubspot.com/carly-weitz/insight-suite?uuid=054daf27-08e5-45ad-95f3-6ba7c6569d95",
                    "_blank"
                  );
                }}
              >
                Learn More
                <div className="btn-icon-container"><img
                  src={upRightBlue}
                  alt="Arrow"
                  className="icon-default"
                  style={{ width: "1rem" }}
                />
                  <img
                    src={upRightArrow}
                    alt="Arrow"
                    className="icon-hover"
                    style={{ width: "1rem" }}
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="imageInsightContainer">
            <img
              src={insightsuite}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}
